module.exports = __webpack_public_path__ + "img/ugatrialgarden-h-474x356.5b2d7d10.jpg";